import { PropertyStatus } from '@tallo/property';

/**
 * The unit statuses an apply link takes applications in, as the backend's applyLinkUnitStatuses: every unit set up to
 * rent, listed or not, since an owner may use Tallo's applications without syndicating through Tallo. Rented out too:
 * marking it rented out turned its old links off, so a link there is one more application the owner chose to take.
 * Never a draft: onboarding is unfinished.
 */
export const applyLinkUnitStatuses: PropertyStatus[] = [
  PropertyStatus.READY_FOR_LISTING,
  PropertyStatus.LISTING_IN_PROGRESS,
  PropertyStatus.LISTED,
  PropertyStatus.UNLISTED,
  PropertyStatus.SYNDICATION_ERROR,
  PropertyStatus.RENTED_OUT,
];
